import Template from "../app/Template";
import Card from "../layout/Card";
import SupportUs from "../landing/SupportUs";

export default function About() {

  return (
    <Template>

      {/* Hero */}
      <div className="hidden lg:block">
        <div
          className="h-[800px] lg:h-[1050px] flex items-center px-8 lg:px-12 relative"
          style={{
            // Image path is relative to the 'public' folder
            backgroundImage: 'url("/img/graphics/hero/about-hero-v2.JPG")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            position: 'relative', // Ensures child elements with absolute positioning are positioned relative to this container
          }}
        >
          <Card className="ml-auto w-4/5 lg:w-4/5 xl:w-3/5 grid grid-cols-1 gap-y-4">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-lg md:text-lg lg:text-2xl font-bold">About RaiseDiversity</h1>
            </div>

            {/* Text */}
            <div className="grid grid-cols-1 gap-y-4 text-dark-grey font-medium">
              <p className="font-bold text-sm lg:text-base">RaiseDiversity is a purpose-led platform built to make it easier to find what matters - bringing trusted, neuro-affirming content and community together in one place.</p>
              <p className="text-sm lg:text-base">We bring together resources that real people trust and recommend - and filter out anything that doesn’t meet our minimum standards. This is a space to explore safely, without deficit-based messaging or outdated assumptions.</p>
              <p className="text-sm lg:text-base">We curate by topic, theme, and journey. We prioritise lived experience - and we amplify the voices sharing knowledge and shifting the narrative, creating peer support groups and alternative education spaces, and offering neuro-affirming tools and training.</p>
              <p className="text-sm lg:text-base">We’re building a different kind of space - where insight is trusted, lived experience is respected, and learning is shared.</p>

              <h1 className="text-dark-grey text-lg md:text-lg lg:text-2xl font-bold">Why I Built It.</h1>
              <p className="text-sm lg:text-base">I spent over 20 years in global companies, but it was navigating the system for my neurodivergent children that changed everything. Like many parents, I found myself deep in research and relentless advocacy - and, like many families, my mother and I recognised ourselves along the way.</p>
              <p className="text-sm lg:text-base">The information was out there, but finding it was another story. It took years to uncover the people and sources I could trust - for my children and for myself - while professionals around us still worked with outdated or incomplete understanding.</p>
              <p className="text-sm lg:text-base">Things are changing, but too many people are still left without clarity, support, or up-to-date insight. I saw a way to help: to bring it all together and make it easier for others to find what I was searching for.</p>
              <p className="text-sm lg:text-base">I didn’t set out to build a platform. I just knew we deserved better.
              </p>
            </div>
          </Card>

          {/* Bubbles */}
          <img
            src="/img/graphics/bubbles/bubble-left-green.svg"
            alt="Bubble"
            className="absolute w-44 object-cover top-36 -right-8 z-0"
          />
          <img
            src="/img/graphics/bubbles/bubble-right-blue.svg"
            alt="Bubble"
            className="absolute w-52 lg:w-64 object-cover bottom-10 lg:bottom-2 right-[33rem] z-0"
          />
        </div>
      </div>

      <div className="block lg:hidden">
        <div
          className="h-fit bg-off-white relative py-12"
        >
          <Card className="w-full grid grid-cols-1 gap-y-4" paddingX="px-8" paddingY="py-8">

            {/* Header */}
            <div>
              <h1 className="text-dark-grey text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold">About RaiseDiversity</h1>
            </div>

            {/* Text */}
            <div className="grid grid-cols-1 gap-y-4 text-dark-grey font-medium">
              <p className="font-bold text-sm lg:text-base">RaiseDiversity is a purpose-led platform built to make it easier to find what matters - bringing trusted, neuro-affirming content and community together in one place.</p>
              <p className="text-sm lg:text-base">We bring together resources that real people trust and recommend - and filter out anything that doesn’t meet our minimum standards. This is a space to explore safely, without deficit-based messaging or outdated assumptions.</p>
              <p className="text-sm lg:text-base">We curate by topic, theme, and journey. We prioritise lived experience - and we amplify the voices sharing knowledge and shifting the narrative, creating peer support groups and alternative education spaces, and offering neuro-affirming tools and training.</p>
              <p className="text-sm lg:text-base">We’re building a different kind of space - where insight is trusted, lived experience is respected, and learning is shared.</p>

              <h1 className="text-dark-grey text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold">Why I Built It.</h1>
              <p className="text-sm lg:text-base">I spent over 20 years in global companies, but it was navigating the system for my neurodivergent children that changed everything. Like many parents, I found myself deep in research and relentless advocacy - and, like many families, my mother and I recognised ourselves along the way.</p>
              <p className="text-sm lg:text-base">The information was out there, but finding it was another story. It took years to uncover the people and sources I could trust - for my children and for myself - while professionals around us still worked with outdated or incomplete understanding.</p>
              <p className="text-sm lg:text-base">Things are changing, but too many people are still left without clarity, support, or up-to-date insight. I saw a way to help: to bring it all together and make it easier for others to find what I was searching for.</p>
              <p className="text-sm lg:text-base">I didn’t set out to build a platform. I just knew we deserved better.
              </p>
            </div>
          </Card>

        </div>
      </div>

      {/* Support us */}
      <SupportUs />

    </Template>
  );
}
